export enum BreachPathEvents {
  OPEN_FEEDBACK_FORM = 'open-feedback-form',
  VIEW_DETAILS = 'view-details',
  VIEW_RESOURCES = 'view-resources',
  NAV_VIEW_RESOURCES_PAGE = 'nav-view-resources-page',
  GO_BACK_DETAILS_PAGE = 'go-back-details-page',
  VIEW_METADATA_RESOURCES_SIDEMENU = 'view-metadata-resources-sidemenu',
  GO_BACK_METADATA_RESOURCES_SIDEMENU = 'go-back-metadata-resources-sidemenu',
}

export enum BreachPathDetailsTabPanels {
  GRAPH,
  RESOURCES,
}

export enum BreachPathIssueNameKey {
  Unknown,

  // AWS
  PublicInternetToEC2ViaPublicIP,
  PublicInternetToApplicationLoadBalancerFQDNtoEC2,
  CloudFrontOptionalToS3PublicToEC2AsAPIServerViaPublicIP,
  CloudFrontOptionalToS3PublicToNetworkLoadBalancerFQDNtoEC2APIServer,
  APIGatewayToNetworkLoadBalancerFQDNtoEC2APIServer,
  PublicInternetToClassicLoadBalancerFQDNtoEC2,

  // AZR
  PublicVM,
  PrivateVMViaLoadBalancer,
  PublicVMViaLoadBalancer,
  OutboundRoutingToVM,
}
